<template>
  <div id="slides">
    <!-- 轮播图 -->
    <swiper :options="swiperOption"
            ref="mySwiper"
            class="swiper-img"
            v-if="swiperList && swiperList.length">
      <swiper-slide v-for="item in swiperList"
                    :key="item"
                    class="swiper-img">
        <!-- <img class="swiper-img" :src="item.type==2?item.cover_url:item.url" alt  @click="item.type==2?playVideo(item):''"> -->
        <img class="swiper-img"
             :src="item.type==2?item.cover_url:item.url"
             alt>
      </swiper-slide>
      <div class="swiper-pagination"
           slot="pagination"
           v-if="flag"></div>
    </swiper>
  </div>
</template>

<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
  name: "slides",
  components: {
    swiper,
    swiperSlide
  },
  props: ["swiperList"],
  data() {
    return {
      swiperOption: {
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        loop: true,
        pagination: { el: ".swiper-pagination" }, // 分页按钮
        autoplay: false
      },
      state: false, //弹窗是否关闭
      vflag: false, //视频播放
      videoUrl: {},
      click: false,
      flag: false
    };
  },
  watch: {
    swiperList: function (val) {
      // 图片一隐藏轮播效果
      if (val.length != 1) {
        this.swiperOption.autoplay = true;
        this.flag = true;
      }
      this.swiperList = val;
    }
  },
  mounted() {
    // 这边就可以使用swiper这个对象去使用swiper官网中的那些方法
    // 方法地址: https://www.swiper.com.cn/api/methods/109.html
    if (this.swiperList && this.swiperList.length) {
      this.$refs.mySwiper.swiper.slideTo(0, 0, false);
    }
  }
};
</script>
<style scoped>
#slides .swiper-img {
  width: 100%;
  /* height: 208px; */
  height: auto;
}
</style>